<template>
    <!--<transition>-->
        <keep-alive>
            <slot></slot>
        </keep-alive>
    <!--</transition>-->
</template>

<script>
    export default {
        name: "empty-layout"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/EmptyLayout.vue